import React from "react";

import MarkdownPage from "../components/MarkdownPage";

const Research = () => {
  return (
    <MarkdownPage url="https://raw.githubusercontent.com/REmatchChile/REmatch-docs/main/research.md" />
  );
};

export default Research;
